<template>
    <div v-show="openOverlay" class="app-loader" :class="{ 'app-loader--closing': closing }">
        <brand-backdrop fade />

        <div class="app-loader-content">
            <span class="app-loader-glow"></span>
            <v-img eager :src="require('@/assets/img/brand_mark.png')" height="152" contain class="logo"/>
        </div>
    </div>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'

import { Storage } from "@/utils/Storage"
import {mapState, mapMutations, mapActions} from 'vuex'
import scrollLock from '@/mixins/scrollLock'
import BrandBackdrop from '@/components/common/BrandBackdrop'

export default {
    components: {
        BrandBackdrop,
    },
    mixins: [scrollLock],
    data() {
        return {
            openOverlay: true,
            closing: false,
            ok: false,
            isNew: false,
            delay: 1000
        }
    },
    mounted() {
        const vm = this
        vm.setLoadingUser(true)
        setTimeout(() => {
            vm.loadApp()
        }, vm.delay)
    },
    computed: mapState(['loadingUser']),
    methods: {
        ...mapMutations(['setLoadingUser']),
        ...mapActions(['initUser', 'setCurrentUser']),
        async loadApp() {
            const vm = this
            try {
                let user = firebase.auth().currentUser
                if (!user) {
                    const credentials = await Storage.getCredentials()
                    if (credentials) user = await vm.waitForAutoLogin()
                }
                if (!user) {
                    console.log('no firebase user', user)
                    vm.ok = false
                    vm.setCurrentUser(null)
                    vm.setLoadingUser(false)
                    return
                }

                vm.isNew = user.metadata.creationTime === user.metadata.lastSignInTime
                vm.ok = true
                await vm.initUser(user)
            } catch (error) {
                console.log('firebase error', error)
                vm.ok = false
                vm.setCurrentUser(null)
                vm.setLoadingUser(false)
            }
        },
        waitForAutoLogin() {
            return new Promise(resolve => {
                let settled = false
                let unsub = null
                const finish = (u) => {
                    if (settled) return
                    settled = true
                    if (unsub) unsub()
                    resolve(u || null)
                }
                unsub = firebase.auth().onAuthStateChanged(u => { if (u) finish(u) })
                setTimeout(() => finish(firebase.auth().currentUser), 6000)
            })
        },
        close() {
            const vm = this

            setTimeout(() => {
                vm.closing = true
            }, vm.delay)

            setTimeout(() => {
                vm.$emit(vm.ok ? 'success' : 'error', this.isNew)
                vm.openOverlay = false
            }, vm.delay + 500)
        }
    },
    watch: {
        loadingUser(val) {
            const vm = this
            if (!val) vm.close()
        }
    }
}

</script>


<style scoped>

.app-loader {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background: #06080C;
    opacity: 1;
    transition: opacity .5s;
}

.app-loader--closing {
    opacity: 0;
}

.app-loader-content {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}

.app-loader-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 320px;
    height: 320px;
    margin: -160px 0 0 -160px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(204, 255, 51, 0.22) 0%, rgba(51, 153, 153, 0.14) 45%, transparent 70%);
    filter: blur(8px);
    animation: app-loader-pulse 2.4s ease-in-out infinite;
}

.logo {
    display: flex;
    flex-direction: row;
    z-index: 1;
}

@keyframes app-loader-pulse {
    0%, 100% { transform: scale(0.85); opacity: 0.55; }
    50%      { transform: scale(1.1); opacity: 1; }
}

</style>
